export default "__VITE_ASSET__DSYtlr0g__"